import { Outlet, Navigate } from "react-router-dom";
var Token = localStorage.getItem("token") ?? null;
const PrivateRoutes = () => {
    return Token !== null ? <Outlet /> : <Navigate to="/login" />;
};
export default PrivateRoutes;